function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { cloneDeep } from '@cloud-sn/v-utils';
import { isSameYear, isBefore, addYears, startOfYear, isAfter, isEqual } from 'date-fns';
import { isValidArray } from './utils';
import MonthYearDecadeCalendar from './monthYearDecadeCalendar';
export default {
  name: 'RangeMonthYearDecadeCalendar',
  provide: function provide() {
    return {
      monthYearDecadeRoot: this
    };
  },
  props: {
    prefixCls: {
      type: String,
      default: ''
    },
    pickerValue: {
      type: Array,
      required: true,
      validator: function validator(val) {
        return val.every(function (v) {
          return v instanceof Date;
        });
      }
    },
    selectedValue: {
      type: Array,
      default: function _default() {
        return [];
      },
      validator: function validator(val) {
        return val.every(function (v) {
          return v instanceof Date;
        });
      }
    },
    mode: {
      type: Array,
      default: function _default() {
        return ['month', 'month'];
      },
      validator: function validator(val) {
        return (val || []).every(function (v) {
          return ['month', 'year', 'decade'].indexOf(v) > -1;
        });
      }
    },
    locale: {
      type: Object,
      default: undefined
    },
    format: {
      type: String,
      default: 'YYYY-MM'
    },
    disabledMonth: {
      type: Function,
      default: function _default() {
        return false;
      }
    },
    disabledYear: {
      type: Function,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      innerPickerValue: [],
      hoverValue: [],
      innerValue: []
    };
  },
  computed: {
    classes: function classes() {
      var _ref;

      var prefixCls = this.prefixCls;
      return _ref = {}, _defineProperty(_ref, prefixCls, true), _defineProperty(_ref, "".concat(prefixCls, "-month-range"), true), _ref;
    },
    startMode: function startMode() {
      var mode = this.mode;

      var _mode = _slicedToArray(mode, 1),
          start = _mode[0];

      return start;
    },
    endMode: function endMode() {
      var mode = this.mode;

      var _mode2 = _slicedToArray(mode, 2),
          end = _mode2[1];

      return end;
    },
    startValue: function startValue() {
      var innerPickerValue = this.innerPickerValue;

      var _innerPickerValue = _slicedToArray(innerPickerValue, 1),
          start = _innerPickerValue[0];

      return start;
    },
    endValue: function endValue() {
      var innerPickerValue = this.innerPickerValue;

      var _innerPickerValue2 = _slicedToArray(innerPickerValue, 2),
          end = _innerPickerValue2[1];

      return end;
    },
    enableMonthNav: function enableMonthNav() {
      var startMode = this.startMode,
          startValue = this.startValue,
          endValue = this.endValue;

      if (startMode === 'month') {
        var next = addYears(startValue, 1);
        return !isSameYear(next, endValue);
      }

      return true;
    }
  },
  watch: {
    selectedValue: function selectedValue(nVal) {
      this.setInnerValue(nVal, false);
      this.setPickerValue(this.normalizeAnchor());
    },
    pickerValue: function pickerValue() {
      this.setPickerValue(this.normalizeAnchor());
    }
  },
  created: function created() {
    var selectedValue = this.selectedValue,
        setInnerValue = this.setInnerValue,
        setPickerValue = this.setPickerValue; // no reactive

    this.firstSelectedVal = null; // no reactive

    setInnerValue(selectedValue, false);
    setPickerValue(this.normalizeAnchor());
  },
  methods: {
    getInnerValue: function getInnerValue() {
      return this.innerValue;
    },
    getHoverValue: function getHoverValue() {
      return this.hoverValue;
    },
    setInnerValue: function setInnerValue(value) {
      var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this.innerValue = value;

      if (trigger) {
        this.$emit('value-change', value);
      }
    },
    setPickerValue: function setPickerValue(value) {
      this.innerPickerValue = value || [];
    },
    getValueFromSelectedValue: function getValueFromSelectedValue(selectedValue) {
      var _selectedValue = _slicedToArray(selectedValue, 2),
          start = _selectedValue[0],
          end = _selectedValue[1];

      var newEnd = end && isSameYear(end, start) ? addYears(end, 1) : end;
      return [start, newEnd];
    },
    normalizeAnchor: function normalizeAnchor() {
      var selectedValue = this.selectedValue,
          pickerValue = this.pickerValue,
          getValueFromSelectedValue = this.getValueFromSelectedValue;
      var normalizedValue = getValueFromSelectedValue(selectedValue);

      if (isValidArray(normalizedValue)) {
        return normalizedValue;
      }

      normalizedValue = getValueFromSelectedValue(pickerValue);

      if (isValidArray(normalizedValue)) {
        return normalizedValue;
      }

      var date = new Date();
      return [date, addYears(date, 1)];
    },
    updateHoverValue: function updateHoverValue(values) {
      var hoverValue = cloneDeep(values);
      this.hoverValue = hoverValue;
      this.$emit('hover-change', hoverValue);
    },
    updateSelectedValue: function updateSelectedValue() {
      var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var updateHoverValue = this.updateHoverValue,
          setInnerValue = this.setInnerValue;

      var _values = _slicedToArray(values, 2),
          start = _values[0],
          end = _values[1];

      setInnerValue(values);

      if (start && !end) {
        updateHoverValue(values);
      }

      this.$emit('calendar-change', values);

      if (!start && !end || start && end) {
        this.firstSelectedVal = null;
        updateHoverValue([]);
        this.$emit('select', values);
      }
    },
    disabledStartYear: function disabledStartYear(year) {
      var endValue = this.endValue;
      var endYear = startOfYear(endValue);
      var curYear = startOfYear(year);
      return isAfter(curYear, endYear) || isEqual(curYear, endYear);
    },
    disabledEndYear: function disabledEndYear(year) {
      var startValue = this.startValue;
      var startYear = startOfYear(startValue);
      var curYear = startOfYear(year);
      return isBefore(curYear, startYear) || isEqual(curYear, startYear);
    },
    onChange: function onChange(value) {
      var firstSelectedVal = this.firstSelectedVal,
          updateSelectedValue = this.updateSelectedValue;
      var values = [];

      if (!firstSelectedVal) {
        this.firstSelectedVal = value;
        values.push(value);
      } else if (isBefore(firstSelectedVal, value)) {
        values.push(firstSelectedVal, value);
      } else {
        values.push(value, firstSelectedVal);
      }

      updateSelectedValue(values);
    },
    onHover: function onHover(_, value) {
      var firstSelectedVal = this.firstSelectedVal,
          updateHoverValue = this.updateHoverValue;

      if (firstSelectedVal) {
        var values = [firstSelectedVal];

        if (isBefore(value, firstSelectedVal)) {
          values.unshift(value);
        } else {
          values.push(value);
        }

        updateHoverValue(values);
      }
    },
    onMonthYearValueChange: function onMonthYearValueChange(direction, value) {
      var innerPickerValue = this.innerPickerValue,
          setPickerValue = this.setPickerValue;
      setPickerValue(direction === 'left' ? [value, innerPickerValue[1]] : [innerPickerValue[0], value]);
    },
    onPanelChange: function onPanelChange(direction, value, next) {
      var startMode = this.startMode,
          endMode = this.endMode,
          innerValue = this.innerValue;
      var pVal = null;
      var pMode = null;

      if (direction === 'left') {
        pVal = [value || innerValue[0], innerValue[1]];
        pMode = [next, endMode];
      } else {
        pVal = [innerValue[0], value || innerValue[1]];
        pMode = [startMode, next];
      }

      this.$emit('panel-change', pVal, pMode);
    }
  },
  render: function render() {
    var h = arguments[0];
    var prefixCls = this.prefixCls,
        locale = this.locale,
        classes = this.classes,
        format = this.format,
        startValue = this.startValue,
        endValue = this.endValue,
        startMode = this.startMode,
        endMode = this.endMode,
        enableMonthNav = this.enableMonthNav,
        disabledMonth = this.disabledMonth,
        disabledStartYear = this.disabledStartYear,
        disabledEndYear = this.disabledEndYear,
        onChange = this.onChange,
        onMonthYearValueChange = this.onMonthYearValueChange,
        onPanelChange = this.onPanelChange;
    var startProps = {
      prefixCls: prefixCls,
      locale: locale,
      format: format,
      value: startValue,
      mode: startMode,
      monthNav: {
        prev: true,
        next: enableMonthNav
      },
      disabledMonth: disabledMonth,
      disabledYear: startMode === 'month' ? disabledStartYear : null
    };
    var endProps = {
      prefixCls: prefixCls,
      locale: locale,
      format: format,
      value: endValue,
      mode: endMode,
      monthNav: {
        prev: enableMonthNav,
        next: true
      },
      disabledMonth: disabledMonth,
      disabledYear: endMode === 'month' ? disabledEndYear : null
    };
    var on = {
      change: onChange
    };

    var startOn = _objectSpread({}, on, {
      'month-value-change': function monthValueChange(value) {
        return onMonthYearValueChange('left', value);
      },
      'year-value-change': function yearValueChange(value) {
        return onMonthYearValueChange('left', value);
      },
      'panel-change': function panelChange() {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return onPanelChange.apply(void 0, ['left'].concat(args));
      }
    });

    var endOn = _objectSpread({}, on, {
      'month-value-change': function monthValueChange(value) {
        return onMonthYearValueChange('right', value);
      },
      'year-value-change': function yearValueChange(value) {
        return onMonthYearValueChange('right', value);
      },
      'panel-change': function panelChange() {
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        return onPanelChange.apply(void 0, ['right'].concat(args));
      }
    });

    return h("div", {
      "class": classes
    }, [h("div", {
      "class": "".concat(prefixCls, "-month-panel")
    }, [h("div", {
      "class": "".concat(prefixCls, "-month-date-panel")
    }, [h("div", {
      "class": ["".concat(prefixCls, "-month-range-part"), "".concat(prefixCls, "-month-range-left")]
    }, [h(MonthYearDecadeCalendar, {
      "props": _objectSpread({}, startProps),
      "on": _objectSpread({}, startOn)
    })]), h("div", {
      "class": ["".concat(prefixCls, "-month-range-part"), "".concat(prefixCls, "-month-range-right")]
    }, [h(MonthYearDecadeCalendar, {
      "props": _objectSpread({}, endProps),
      "on": _objectSpread({}, endOn)
    })])])])]);
  }
};